import { type SubscriptionHookOptions, useSubscription } from "@apollo/client";
import { ContentStreamStatusChangedSubscription } from "../graphql/subscriptions";
import type {
  ContentStreamStatusChangedSubscriptionType,
  ContentStreamStatusChangedSubscriptionVariablesType,
} from "@/types/graphql/partner.generated";

export const useContentStreamStatusChangedSubscription = (
  options?: SubscriptionHookOptions<
    ContentStreamStatusChangedSubscriptionType,
    ContentStreamStatusChangedSubscriptionVariablesType
  >
) => {
  return useSubscription<
    ContentStreamStatusChangedSubscriptionType,
    ContentStreamStatusChangedSubscriptionVariablesType
  >(ContentStreamStatusChangedSubscription, options);
};
